/**
 * Company: SPHMedia
 * Description: Configuration for the /internal/subscribe route, which SSR-embeds
 * the Berita Harian eShop precheckout ("subscribe") partial through the shared
 * @sphtech/eshop-partials-embed package.
 */
import type { SubscribeSeo } from "@sphtech/eshop-partials-embed/precheckout/subscribe-constants";

/**
 * eShop CDN origin the partial (and its bundle assets) are fetched from.
 * Server-side config. An empty/unset value makes the package fall back to its
 * UAT origin (https://uat-remote.subscribe.sph.com.sg), so the UAT test site
 * works without extra Lambda configuration; production must set
 * VITE_ESHOP_CDN_URL to the production origin.
 */
export const ESHOP_CDN_BASE = import.meta.env.VITE_ESHOP_CDN_URL ?? "";

/** Locale + publication segments of the partial's CDN path. */
export const ESHOP_SUBSCRIBE_LOCALE = "ms";
export const ESHOP_SUBSCRIBE_PUBLICATION = "bh-subscribe";

/**
 * SEO used when neither the route's embed.json manifest nor its seo.json
 * sidecar supplies it. Robots is not set here: `meta` forces noindex,nofollow
 * on this precheckout page regardless of the payload.
 */
export const SUBSCRIBE_DEFAULT_SEO: SubscribeSeo = {
  title: "Beritaharian - Berita Utama, Singapura, Ekoniaga, Dunia & Sukan",
  description:
    "Berita Harian Singapura - Dapatkan berita utama, laporan eksklusif, analisis mendalam dan kandungan berbilang media mengenai Singapura, Asia dan dunia.",
};
